import { NavItemExternalLink } from '@/domain/navigation/features/navigation/components/MobileNavItem/NavItem';
import { useProfile } from '@/hooks';
import { buildLink } from '@/utils';
import { useTranslation } from 'react-i18next';

export function useControllingSubmenuItems() {
  const { t } = useTranslation();
  const profile = useProfile();
  const manager = profile.manager;
  const menuItems = [];

  if (manager.rechte.tagebuch) {
    menuItems.push(
      <NavItemExternalLink href={buildLink('tagebuch')}>
        {t('entities.journal')}
      </NavItemExternalLink>,
    );
  }
  if (manager.rechte.auswertung.dienstplan) {
    menuItems.push(
      <NavItemExternalLink href={buildLink('auswertungenDienstplan')}>
        {t('entities.analysis_other')}
      </NavItemExternalLink>,
    );
  }
  if (manager.isPersonalAuswerter()) {
    menuItems.push(
      <NavItemExternalLink href={buildLink('auswertungenPersonal')}>
        {t('entities.analysis_other')}
      </NavItemExternalLink>,
    );
  }
  if (manager.isArbeitszeitAuswerter()) {
    menuItems.push(
      <NavItemExternalLink href={buildLink('auswertungenArbeitszeit')}>
        {t('entities.analysis_other')}
      </NavItemExternalLink>,
    );
  }

  return menuItems;
}
